let baseZIndex = 100000;

export function getHighZIndex() {
    return ++baseZIndex;
}
